<template>
    <div class="project-container">
        <div class="top-title">
            <h2>宁夏彭阳县古城镇温沟村日光温室示范园区自动化项目</h2>
        </div>

        <!-- 证书与描述区 -->
        <el-row :gutter="16" class="main-content">
            <!-- 左侧：数字农业智能驾驶舱 -->
            <el-col :span="8">
                <img :src="dashboardImg" alt="数字农业智能驾驶舱" class="main-img">
            </el-col>

            <!-- 右侧：平台描述 -->
            <el-col :span="14">
                <div class="desc-card">
                    <p>
                        我公司于2023年启动宁夏彭阳县古城镇温沟村日光温室示范园区自动化项目，聚焦高原特色设施农业升级需求，以物联网、大数据及智能控制技术为支撑，建成集环境感知、智能决策、自动化执行为一体的现代化日光温室集群。
                    </p>
                    <p>
                        项目通过部署全环境监测系统（温/湿度、光照、CO₂浓度）、智能灌溉/通风/补光系统、病虫害预警模块，实现温室内参数全自动智能化调控，大幅降低人工依赖，显著提升资源利用效率与生产标准化水平。同步搭建农事追溯系统与管理平台，推动种植管理从“经验驱动”向“数据驱动”转型。
                    </p>
                    <p>
                        该项目作为“智慧农业+生态循环”标杆案例获多地观摩，助力地方构建“设施化、标准化、数字化”高效农业样板，为西北区域设施农业绿色可持续发展提供创新范式。
                    </p>
                </div>
            </el-col>
        </el-row>

        <!-- 底部图片展示区 -->
        <div class="image-grid">
            <el-row :gutter="15">
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/pyone.png" alt="" class="project-img">
                    <p class="img-p">
                        安装日光温室各类传感器
                    </p>
                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/pytwo.png" alt="" class="project-img">
                    <p class="img-p">
                        安装室外气象站
                    </p>
                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/pythree.png" alt="" class="project-img">
                    <p class="img-p">
                        安装103座卷帘机自动止停系统
                    </p>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NingxiaProjectPage',
    data() {
        return {
            dashboardImg: require('@/assets/images/HardwareDetails/juanlianji-qj/yxms.png')

        }
    }
}
</script>